import React from "react"
import Step from "../base-pages/step"

const StepEN = () => {
  return <Step lang="en" />
}

export default StepEN
